import { Flex, Hide } from 'mds-web-ui'
import React, { forwardRef } from 'react'

import { HeaderMenu } from './HeaderMenu'
import { MiniBanner } from './MiniBanner'

export const TopNav = forwardRef(
  (
    {
      position = 'absolute',
      fullWidth = true,
      maxWidth = 1400,
      searchPlaceholder,
      imageData,
      theme = 'light',
      ...props
    },
    ref
  ) => {
    const themeColor = theme === 'light' ? 'var(--msk-color)' : '#fff'
    const themeBg = theme === 'light' ? 'var(--msk-bg)' : '#0a0a0a'

    // Determine if the page was redirected from a previous domain
    const fromRedirect =
      typeof window !== 'undefined' &&
      window.location.search.includes('source=mds')

    return (
      <Flex
        as="nav"
        {...props}
        alignItems="center"
        justifyContent="center"
        width="100%"
        css={{ a: { lineHeight: 1 }, position: position, top: 0, zIndex: 9999 }}
        bg={theme === 'transparent' ? 'transparent' : themeBg}
        color={themeColor}
        ref={ref}
        id="bonobo__nav"
      >
        <Flex
          maxWidth={fullWidth ? 'initial' : maxWidth}
          width="100%"
          alignItems={['start', 'start', 'start', 'center']}
          py={3}
          px={fullWidth ? [3, 4] : 3}
          flexDirection={['column', 'column', 'column', 'row']}
          gap={[3, 3, 0, 3]}
        >
          <HeaderMenu
            color={themeColor}
            theme={theme}
            iconColor={themeColor}
            searchPlaceholder={searchPlaceholder}
            imageData={imageData}
          />

          {fromRedirect ? (
            <Hide l width="100%">
              <MiniBanner>We changed our name!</MiniBanner>
            </Hide>
          ) : null}
        </Flex>
      </Flex>
    )
  }
)

export default TopNav
